module.exports = "/_next/static/images/de-header-logo-8d4c0bbf82cfecdab9a2248a046994fc.svg";